import React from "react";

const DrawerIcon = ({ className, color }) => {
  return (
    <svg
      className={className}
      fill={color || "#000000"}
      viewBox="0 -3 32 32"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path d="M29.901,26.000 L2.081,26.000 C0.985,26.000 0.000,25.103 0.000,24.000 L0.000,12.000 C0.000,11.801 0.086,11.626 0.201,11.470 L3.110,0.737 C3.228,0.302 3.620,-0.000 4.068,-0.000 L27.914,-0.000 C28.362,-0.000 28.754,0.302 28.872,0.737 L31.774,11.446 C31.904,11.607 32.000,11.790 32.000,12.000 L32.000,24.000 C32.000,25.103 30.996,26.000 29.901,26.000 ZM30.000,24.000 L30.000,13.000 L21.870,13.000 C21.396,15.834 18.940,18.000 15.991,18.000 C13.042,18.000 10.587,15.834 10.113,13.000 L2.000,13.000 L2.000,24.000 L30.000,24.000 ZM27.155,2.000 L4.827,2.000 L2.389,11.000 L11.023,11.000 C11.572,11.000 12.017,11.448 12.017,12.000 C12.017,14.206 13.800,16.000 15.991,16.000 C18.183,16.000 19.965,14.206 19.965,12.000 C19.965,11.448 20.410,11.000 20.959,11.000 L29.594,11.000 L27.155,2.000 Z"></path>{" "}
      </g>
    </svg>
  );
};

export default DrawerIcon;
